'use client';

import { WebAPIEventsPage } from '@/globals/webApiTypes/pages/WebAPIEventsPage';
import { useSelectedFilters } from '@/sections/filter/useSelectedFilters';
import { filterEventResults } from './filterEventResults';

export const EventOverlayTotalResults = ({
	results,
	filters,
}: {
	results: WebAPIEventsPage['results'];
	filters: WebAPIEventsPage['filters'];
}) => {
	const [selectedFilters] = useSelectedFilters();
	const filteredResultsAmount = filterEventResults(
		results,
		selectedFilters,
		filters,
	).length;

	return <>{`(${filteredResultsAmount})`}</>;
};
